import User from 'records/User';
import Base from 'records/Base';

import {
  USER_REGISTER_ASYNC_ACTION_START,
  USER_REGISTER_ASYNC_ACTION_SUCCESS,
  USER_REGISTER_ASYNC_ACTION_ERROR,
  USER_UPDATE_ACTION,
  USER_ASYNC_ACTION_START,
  USER_ASYNC_ACTION_ERROR,
  USER_UPDATE_ACTION_SUCCESS,
  USER_UPDATE_ACTION_ERROR,
  RESET_PASSWORD_ASYNC_ACTION_START,
  RESET_PASSWORD_ASYNC_ACTION_ERROR,
  RESET_PASSWORD_ASYNC_ACTION_SUCCESS,
  USER_RESET_STATE,
  USER_VALIDATION_LEGAL_ACTION_SUCCESS,
  MFA_ASYNC_ACTION_START,
  MFA_ASYNC_ACTION_ERROR,
  MFA_ASYNC_ACTION_SUCCESS
} from 'actions/user';

const initialState = new Base({
  loading: false,
  errorMessage: null,
  data: new User(),
});

const actionsMap = {
  [USER_REGISTER_ASYNC_ACTION_START]: (state) => {
    return state.merge({
      loading: true,
      errorMessage: null,
    });
  },
  [USER_REGISTER_ASYNC_ACTION_ERROR]: (state, action) => {
    return state.merge({
      loading: false,
      errorMessage: action.error,
      data: new User(),
    });
  },
  [USER_ASYNC_ACTION_START]: (state) => {
    return state.merge({
      loading: true,
      errorMessage: null,
    });
  },
  [USER_ASYNC_ACTION_ERROR]: (state, action) => {
    return state.merge({
      loading: false,
      errorMessage: action.error,
    });
  },
  [USER_REGISTER_ASYNC_ACTION_SUCCESS]: (state) => {
    return state.merge({
      loading: false,
      errorMessage: null,
    });
  },
  [USER_UPDATE_ACTION_SUCCESS]: (state, action) => {
    const newUser = new User(action.data);
    return state.merge({
      loading: false,
      errorMessage: null,
      data: newUser,
    });
  },
  [USER_UPDATE_ACTION]: (state, action) => {
    return state.merge({
      loading: false,
      errorMessage: null,
      data: action.data,
    });
  },
  [USER_UPDATE_ACTION_ERROR]: (state, action) => {
    return state.merge({
      loading: false,
      errorMessage: action.error,
    });
  },
  [RESET_PASSWORD_ASYNC_ACTION_START]: (state) => {
    return state.merge({
      loading: true,
      errorMessage: null,
    });
  },
  [RESET_PASSWORD_ASYNC_ACTION_ERROR]: (state, action) => {
    return state.merge({
      loading: false,
      errorMessage: action.error,
    });
  },
  [RESET_PASSWORD_ASYNC_ACTION_SUCCESS]: (state) => {
    return state.merge({
      loading: false,
      errorMessage: null,
    });
  },
  [MFA_ASYNC_ACTION_START]: (state) => {
    return state.merge({
      loading: true,
      errorMessage: null,
    });
  },
  [MFA_ASYNC_ACTION_ERROR]: (state, action) => {
    return state.merge({
      loading: false,
      errorMessage: action.error,
    });
  },
  [MFA_ASYNC_ACTION_SUCCESS]: (state) => {
    return state.merge({
      loading: false,
      errorMessage: null,
    }).setIn(['data', 'mfaAlertedFlag'], true)
  },
  [USER_VALIDATION_LEGAL_ACTION_SUCCESS]: (state, action) => {
    return state.merge({
      loading: false,
      errorMessage: null,
      data: new User(action.data),
    })
  },
  [USER_RESET_STATE]: () => {
    return initialState;
  },
};

export default function user(state = initialState, action = {}) {
  const fn = actionsMap[action.type];
  return fn ? fn(state, action) : state;
}
